import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserCircle2, LayoutDashboard, Wallet, Crown, LogOut } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ShareButton } from "@/components/ShareButton";
import { NotificationBell } from "@/components/NotificationBell";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function AccountMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState({ plan: "", balance: null });

  useEffect(() => {
    if (!user) return;
    Promise.all([api.get("/usage").catch(() => null), api.get("/wallet").catch(() => null)]).then(([u, w]) =>
      setInfo({ plan: u?.data?.plan?.name || "", balance: w?.data?.balance ?? null }));
  }, [user]);

  const isAdmin = user?.role === "admin";
  return (
    <div className="flex items-center gap-2">
      <span className="hidden sm:inline-flex"><ShareButton compact /></span>
      <NotificationBell />
      <Button onClick={() => navigate("/app")} className="bg-primary hover:bg-primary/90 text-white gap-1.5" data-testid="nav-dashboard-btn">
        <LayoutDashboard className="w-4 h-4" /> <span className="whitespace-nowrap">لوحة العمل</span>
      </Button>
      <DropdownMenu dir="rtl">
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="border-border gap-1.5" data-testid="nav-account-btn">
            <UserCircle2 className="w-4 h-4" /> <span className="hidden sm:inline">حسابي</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-60 bg-popover border-border" data-testid="account-menu">
          <DropdownMenuLabel className="font-normal">
            <div className="text-sm font-bold truncate" data-testid="account-name">{user?.name}</div>
            <div className="text-xs text-muted-foreground truncate" data-testid="account-email">{user?.email}</div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => navigate("/app/packages")} className="gap-2 cursor-pointer" data-testid="account-plan">
            <Crown className="w-4 h-4 text-accent" /> الباقة: <b>{info.plan || "—"}</b>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/app/packages")} className="gap-2 cursor-pointer" data-testid="account-wallet">
            <Wallet className="w-4 h-4 text-accent" /> المحفظة: <b>{info.balance ?? "—"} ريال</b>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => navigate("/app")} className="gap-2 cursor-pointer" data-testid="account-dashboard">
            <LayoutDashboard className="w-4 h-4 text-primary" /> لوحة العمل
          </DropdownMenuItem>
          {isAdmin && (
            <DropdownMenuItem onClick={() => navigate("/app/admin-overview")} className="cursor-pointer justify-center text-sm opacity-60 hover:opacity-100" data-testid="account-admin" aria-label="admin">
              ™🇸🇦
            </DropdownMenuItem>
          )}
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={async () => { await logout(); navigate("/"); }} className="gap-2 cursor-pointer text-destructive" data-testid="account-logout">
            <LogOut className="w-4 h-4" /> تسجيل الخروج
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
